import { useAuth0 } from "@auth0/auth0-react";
import IFrameDisplay from "components/iframe-display";
import { getCustomerConfig } from "./dashboard-config";
import TractorsGate from "./tractors-gate";
import DashboardLayout from "components/dashboard-layout/dashboard-layout";
import BlogPage from "features/app/blog/blog";
import BlogSinglePage from "features/app/blog/blog-single";
import FuelLocationsPage from "features/app/fuel-locations/fuel-locations";
import FuelOptimizerPage from "features/app/fuel-optimizer/fuel-optimizer";
import FuelPlanCompliancePage from "features/app/fuel-plan-compliance/fuel-plan-compliance";
import TractorsPage from "features/app/tractors/tractors";
import { Navigate, Route, Routes } from "react-router-dom";
import { FuelSolutionsIndex } from "features/app/fuel-solutions/fuel-solutions";
import { publicRoutes } from "./public-routes";

const AuthApp = () => {
    const { user } = useAuth0();
    const customerConfig = getCustomerConfig(user!["https://ifuelsmart.com/company"]);

    return (
        <>
            <Routes>
                {publicRoutes}
                <Route
                    path="app"
                    element={
                        <>
                            <style
                                dangerouslySetInnerHTML={{
                                    __html: `#bs-chatbot-widget-container__21E7F { display: none; }`,
                                }}
                            />
                            <TractorsGate>
                                <DashboardLayout />
                            </TractorsGate>
                        </>
                    }
                >
                    <Route index element={<FuelOptimizerPage />} />
                    <Route path="fuel-solutions" element={<FuelSolutionsIndex />} />
                    <Route path="fuel-locations" element={<FuelLocationsPage />} />
                    <Route path="tractors" element={<TractorsPage />} />
                    {customerConfig.hasFuelStopCompliance && (
                        <Route path="fuel-stop-compliance" element={<FuelPlanCompliancePage />} />
                    )}
                    <Route path="blogs">
                        <Route index element={<BlogPage />} />
                        <Route path=":slug" element={<BlogSinglePage />} />
                    </Route>
                    {/* Custom Features Routes */}
                    {customerConfig.customFeatures.map((feature) => (
                        <Route
                            key={feature.route}
                            path={feature.route.split("/")[1]}
                            element={<IFrameDisplay url={feature.iframeUrl} name={feature.name} />}
                        />
                    ))}
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </>
    );
};

export default AuthApp;
